import { CallbackObject } from 'api/core/get-page-function';
import { plainToClass } from 'class-transformer';
import { GetAreasVm } from './get-areas.vm';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';

export const getAreas = async (warehouseId: string, offset: string, callback: CallbackObject<GetAreasVm>) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      limit: 50,
      offset: offset,
    },
  };

  try {
    const res: AxiosResponse = await instance.get(`/warehouse/warehouses/${warehouseId}/areas`, config);
    callback.success(plainToClass(GetAreasVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
